import {Controller} from "stimulus"
import Splide from "@splidejs/splide"

export default class extends Controller {

    static targets = [
        "container"
    ]

    initialize() {

        let options = {
            // rewind: true,
            // rewindSpeed: 400,
            speed: 300,
            perPage: 1,
            type: 'slide', //slide | loop | fade
            gap: 0,
            pagination: false,
            autoplay: false,
            // interval: 500,
            arrows: true,
            slideFocus: false, //INDEX
            easing: 'cubic-bezier(.42,.65,.27,.99)',
            breakpoints: {
                1000: {
                    perPage: 4,
                },
                700: {
                    perPage: 3,
                },
                500: {
                    perPage: 2,
                },
                400: {
                    perPage: 1,
                }
            }
        }

        options = Object.assign({}, options, this.options)

        new Splide( this.containerTarget, options).mount();
    }

    get options() {
        const options = this.data.get("options")
        return options ? JSON.parse(options) : {}
    }

}
